Apt.fn.make('home', {
	/**
	 * Initialize module
	 */
	init: function() {
		$.events.on({
			'ref:creatorNav': {
				click: function(e, el) {
					$.history.go('/bathroom/faucets/creator#' + el.dataset.target);
				}
			},
			'ref:creatorStyle': {
				click: function(e, el) {
					var value = el.dataset.value,
						path = '/bathroom/faucets/creator';

					if (value) {
						path += '?style=' + value;
					}

					$.history.go(path + '#spout');
				}
			}
		}, {
			namespace: 'home'
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('home');
	}
});